import React, { useEffect, useState } from "react";
import {
  Button,
  FormGroup,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  Row,
  Col,
  Container,
  Input,
  Label,
  NavLink as TabLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import classnames from "classnames";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import Calendar from 'react-calendar';
// import 'react-calendar/dist/Calendar.css';
import { requestApi } from "../../../request-api";
import { useNavigate, useParams } from "react-router-dom";
import { directUrl, homePageUrl } from "../../../helpers/Constants";

//assets
import upload from "../../../assets/image/icons/upload.svg";
import { async } from "q";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Triangle } from "react-loader-spinner";
import axios from "axios";
import { API_URL } from "../../../config";
import { userStore } from "../../../stores";

function UpdateBranch() {
  let navigate = useNavigate();

  let [currentActiveTab, setCurrentActiveTab] = useState("1");
  let [calendarValue, setCalenderValue] = useState(new Date());
  let [showCalender, setShowCalender] = useState(false);
  let [selectedDate, setSelectedDate] = useState("");
  let [companyName, setCompanyName] = useState("");
  let [branchPocNumber, setBrachPocNumber] = useState("");
  let [branchId, setBranchId] = useState("");
  let [pocNumber, setPocNumber] = useState("");
  let [complainceOfficer, setComplianceOfficer] = useState("");
  let [emailId, setEmailId] = useState("");
  let [officeAddress, setOfficeAddress] = useState("");
  let [company, setCompany] = useState([]);
  let [branch, setBranch] = useState([]);
  let [compliancer, setCompliancer] = useState([]);
  const [fileData, setFileData] = useState([]);
  let [filetxt, setFiletxt] = useState("Choose File");
  let [browseremove, setBrowseremove] = useState("Browse");
  let [formErrors, setFormErrors] = useState({});
  let [isSubmit, setIsSubmit] = useState(false);
  let [loading, setLoading] = useState(false);
  let [modal, setModal] = useState(false);
  let { id } = useParams();
  const [startDate, setStartDate] = useState(new Date());
  
 

  const successToast = (message) =>
    toast.success(message, {
      position: "bottom-right",
    });

  const errorToast = (error) =>
    toast.error(error, {
      position: "bottom-right",
    });

    const onFileChange = (event) => {
      setFileData(event.target.files[0]);
    };
    const toggle = (tab) => {
      if (currentActiveTab !== tab) {
        setCurrentActiveTab(tab);
      }
    };

    
    

  useEffect(() => {
    requestApi(`/auditor/branch/getBranchById/${id}`, {
      method: "get",
    }).then((data) => {
      getCompany();
      console.log("Ayan", data.data[0].id);
      // setCompany(data.data);
      setCompanyName(data.data[0].company_name);
      setBrachPocNumber(data.data[0].branch_poc_name);
      setBranchId(data.data[0].branch_id);
      setPocNumber(data.data[0].poc_number);
      console.log("------>",data.data[0].compliance_officer_id)
      setComplianceOfficer(data.data[0].compliance_officer_id);
      console.log("data.data[0].compliance_officer_id",complainceOfficer)
      setEmailId(data.data[0].email_id);
      setOfficeAddress(data.data[0].office_address);

      setSelectedDate(data.data[0].date_of_joining);
    });
  }, []);

  const getCompany = async () => {
    await requestApi("/auditor/company/getCompanyByUserId", {
      method: "get",
    }).then((data) => {
      let company = [];
      data.data.map((comp) => {
        company.push(comp.company_name);
      });
      setCompany(company);
    });
    await requestApi("/auditor/getComplianceofficer", {
      method: "get",
    }).then((data) => {
      let complianceOfficer = [];
      data.data.map((comp) => {
        complianceOfficer.push(comp.name);
      });
      setCompliancer(complianceOfficer);
    });
  };

  const customModal = () => {
    console.log("method called", modal);
    setModal(!modal);
  };

  const submitForm = (e) => {
    setLoading(true)
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", fileData);
    formData.append("filename", fileData.name);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: userStore.token || "",
      },
    };
    return axios
      .post(`${API_URL}/auditor/branch/uploadBranch`, formData, config)
      .then((data) => {
        setLoading(false)
        if(data.data.statusCode === 200){

            successToast("Successfully created bulk branch")
            navigate(`${directUrl}auditor/branch`); 
        }
       
      }).catch((error)=>{
        setLoading(false)
           errorToast(error.message) 
      })
  };

  useEffect(() => {
    setSelectedDate(
      `${calendarValue.getDate()}/${
        calendarValue.getMonth() + 1
      }/${calendarValue.getFullYear()}`
    );
  }, [calendarValue]);

  const createNewBranch = async () => {
    console.debug("sending code", complainceOfficer);
    requestApi(`/auditor/branch/updateBranch/${id}`, {
      method: "put",
      body: JSON.stringify({
        company_name: companyName,
        branch_id: branchId,
        branch_poc_name: branchPocNumber,
        date_of_joining: startDate,
        poc_number: pocNumber,
        compliance_officer_id: complainceOfficer == null ? '': complainceOfficer,
        email_id: emailId,
        office_address: officeAddress,
      }),
    }).then((data) => {
      console.log(data);
      if (data.statusCode === 200) {
        navigate(`${directUrl}auditor/branch`);
      }
    });
  };

  const formValidation = (values) => {
    setLoading(true)
    console.log(startDate);
    const errors = {};
    const mobRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    const emailRegex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if(currentActiveTab === "1"){
    if (companyName == '') {
      errors.companyname = "Company Name is required";
    }else if (companyName == 'Select Company') {
        errors.companyname = "Company Name is required";
      }
    if (branchPocNumber == '') {
      errors.branchpocname = "Branch POC Name is required";
    }
    if (branchId == '') {
      errors.branchid = "Branch ID is required";
    }
    if (pocNumber == '') {
      errors.pocnumber = "POC Number is required";
    } else if (!mobRegex.test(pocNumber)) {
      errors.pocnumber = "Invalid Number";
    }
    if (emailId == '') {
      errors.email = "Email Address is required";
    } else if (!emailRegex.test(emailId)) {
      errors.email = "Invalid Email Address";
    }
    if (officeAddress == '') {
      errors.officeadd = "Office Address is required";
    }
    // if (!values.datepicker) {
    //   errors.datepicker = "Date is required";
    // }
    // if (complainceOfficer == '') {
    //   errors.selectofficer = "Select Officer is required";
    // } else if (complainceOfficer == 'Select Complaince Officer') {
    //   errors.selectofficer = "Select Officer is required";
    // }
    setLoading(false)
}
    if(currentActiveTab === "2"){
        if (fileData.length== 0) {
            errors.file = "File is required";
          } else {
            customModal();
          }
          setLoading(false)
    }
  

    return errors;
  };

  const validateBanner = async (e) => {
    e.preventDefault();
    setIsSubmit(true);
    const validate = await formValidation()
    setFormErrors(validate);
    console.log("validate",validate)

    if (Object.keys(validate).length == 0) {
    if(currentActiveTab === "1"){
        createNewBranch(e);
    }else{
        submitForm(e)
    }
        
    }
  };

  const file_select = (e) => {
    onFileChange(e) 
    if (e.target.files[0] == null) {
      setFiletxt("Choose File");
      setBrowseremove("Browse");
    } else {
      const filepath = e.target.files[0].name;
      setFiletxt(filepath);
      setBrowseremove("Choose Again");
    }
  };




  return (
    <main onClick={() => setShowCalender(!showCalender)}>
      <section className="lyt-section"></section>
      {
        loading?(
      <div className="loader-container">
        <div className="spinner"></div>
      </div>
        ):null
      }
      <section className="lyt-section p-0">
        <Container fluid className="typ-container">
          <div className="bs-card">
            <Row>
              <div className="bs-tabs">
                <Nav tabs>
                  <NavItem>
                    <TabLink
                      className={classnames({
                        active: currentActiveTab === "1",
                      })}
                      onClick={() => {
                        toggle("1");
                      }}
                    >
                      Create Branch
                    </TabLink>
                  </NavItem>
                 
                </Nav>
              </div>
              <TabContent activeTab={currentActiveTab} className="px-0">
                <TabPane tabId="1">
                  <Container fluid>
                    <FormGroup className="bs-form">
                      <Row>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <Label
                            for="examplePassword"
                            className="mr-sm-2 cstm-label"
                          >
                            Company Name
                          </Label>
                          <Input
                            className="typ-select mob-margin cstm-input"
                            type="select"
                            value={companyName}
                            name="name"
                            id="exampleSelect"
                            onChange={(e) => {
                              setCompanyName(e.target.value);
                            }}
                          >
                            <option>Select Company</option>
                            {company.map((comp) => {
                              return (
                                <option key={comp} value={comp}>
                                  {comp}
                                </option>
                              );
                            })}
                          </Input>
                          <p className="error-message">
                              {formErrors.companyname}
                            </p>
                        </Col>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <Label
                            for="examplePassword"
                            className="mr-sm-2 cstm-label"
                          >
                            Branch POC Name
                          </Label>
                          {console.log(branchPocNumber)}
                          <Input
                            type="text"
                            name="text"
                            id="examplePassword"
                            className="cstm-input"
                            value={branchPocNumber}
                            placeholder="Enter POC Name"
                            onChange={(e) => {
                              setBrachPocNumber(e.target.value);
                            }}
                          />
                            <p className="error-message">
                              {formErrors.branchpocname}
                            </p>
                        </Col>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <Label
                            for="exampleEmail"
                            className="mr-sm-2 cstm-label"
                          >
                            Branch ID
                          </Label>
                          <Input
                            type="text"
                            name="text"
                            id="exampleEmail"
                            className="cstm-input"
                            placeholder="Enter Branch ID"
                            value={branchId}
                            onChange={(e) => {
                              setBranchId(e.target.value);
                            }}
                          />
                          <p className="error-message">
                              {formErrors.branchid}
                            </p>
                        </Col>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <Label
                            for="examplePassword"
                            className="mr-sm-2 cstm-label"
                          >
                            Date of Joining
                          </Label>
                          {/* <div class="searchbox-wrap">
                                                <Input type="text" name="date" id="examplePassword" className='cstm-input' placeholder="Enter Date of Joining" />
                                                <button className='bs-btn typ-date'><span class="icon-calendar"></span></button>
                                            </div> */}
                          {/* {showCalender && <div className='bs-calender'>
                                                <Calendar onChange={setCalenderValue} value={calendarValue} />
                                            </div>} */}
                          <div className="calender-area">
                            <DatePicker
                              disabled
                              value={selectedDate}
                              onChange={(date) => setStartDate(date)}
                              placeholderText="Enter Date of Joining"
                            />
                          </div>
                          <p className="error-message">
                                {formErrors.datepicker}
                              </p>
                        </Col>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <Label
                            for="exampleEmail"
                            className="mr-sm-2 cstm-label"
                          >
                            POC Number
                          </Label>
                          <Input
                            type="text"
                            name="text"
                            id="exampleEmail"
                            className="cstm-input"
                            value={pocNumber}
                            placeholder="Enter POC Number"
                            onChange={(e) => {
                              setPocNumber(e.target.value);
                            }}
                          />
                           <p className="error-message">
                              {formErrors.pocnumber}
                            </p>
                        </Col>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <Label
                            for="examplePassword"
                            className="mr-sm-2 cstm-label"
                          >
                            Assign Compliance Officer
                          </Label>
                          <Input
                            className="typ-select mob-margin"
                            type="select"
                            name="select"
                            value={complainceOfficer}
                            id="exampleSelect"
                            onChange={(e) => {
                              setComplianceOfficer(e.target.value);
                            }}
                          >
                            <option>Select Compliance Officer</option>
                            {compliancer.map((comp) => {
                              return (
                                <option key={comp} value={comp}>
                                  {comp}
                                </option>
                              );
                            })}
                          </Input>
                          <p className="error-message">
                              {formErrors.selectofficer}
                            </p>
                        </Col>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <Label
                            for="exampleEmail"
                            className="mr-sm-2 cstm-label"
                          >
                            Email ID
                          </Label>
                          <Input
                            type="email"
                            name="email"
                            className="cstm-input"
                            id="exampleEmail"
                            value={emailId}
                            placeholder="Enter Email ID"
                            onChange={(e) => {
                              setEmailId(e.target.value);
                            }}
                          />
                           <p className="error-message">{formErrors.email}</p>
                        </Col>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <Label for="exampleText" className="cstm-label">
                            Office Address
                          </Label>
                          <Input
                            type="textarea"
                            name="text"
                            className="cstm-input"
                            rows="5"
                            id="exampleText"
                            value={officeAddress}
                            placeholder="Enter Office Address"
                            onChange={(e) => {
                              setOfficeAddress(e.target.value);
                            }}
                          />
                           <p className="error-message">
                              {formErrors.officeadd}
                            </p>
                        </Col>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <button
                            className="bs-btn "
                            type="button"
                            onClick={(e) => {
                              validateBanner(e)
                            }}
                          >
                            SUBMIT
                          </button>
                        </Col>
                      </Row>
                    </FormGroup>
                  </Container>
                </TabPane>
                
              </TabContent>
            </Row>
          </div>
        </Container>
        <ToastContainer />
      </section>

     
    </main>
  );
}

export default UpdateBranch;
